import { EKYCStatus } from "./EKYCStatus";
import { ETreasuryPrimeKycResult } from "./ETreasuryPrimeKycResult";

export const EKYCStatusToTreasuryPrimeKycResult: Partial<
  Record<EKYCStatus, ETreasuryPrimeKycResult>
> = {
  [EKYCStatus.APPROVED]: ETreasuryPrimeKycResult.ok,
  [EKYCStatus.MANUAL_REVIEW]: ETreasuryPrimeKycResult.pending,
};
